import React from 'react'

import { WebhooksView } from './WebhooksView'
import { useWebhooks } from './hooks/useWebhooks'

export const WebhooksContainer = () => {
  const { webhooks, clientSecret, isLoading, onWebhookCreate } = useWebhooks()

  return (
    <WebhooksView
      webhooksListProps={{
        data: webhooks,
        isLoading,
      }}
      clientSecret={clientSecret}
      onWebhookCreate={onWebhookCreate}
    />
  )
}
